import Axios from 'axios'
import { io } from 'socket.io-client'
import { SERVER_BASE_URL, WEBSOCKET_URL } from './baseUrl'

const socket = io(WEBSOCKET_URL, { transports: ['websocket'] })

export const createNotifications = async (
  token: string,
  name: string,
  userEmail: string[],
  content: object,
) => {
  try {
    const response: unknown[] = []
    const recipients = (userEmail || []).filter((e) => Boolean(e && e !== 'undefined'))
    if (!recipients.length) {
      console.warn('[Notifications] Aucun destinataire valide pour createNotifications', userEmail)
      return response
    }

    for (const email of recipients) {
      const notifId = crypto.randomUUID() // `${socket.id}${Math.random()}`

      socket.emit('notif', {
        content,
        name,
        userEmail: email,
        notifId: notifId,
        socketID: socket.id,
      })
      const res = await Axios.post(
        `${SERVER_BASE_URL}api/notifications`,
        {
          userEmail: email,
          content,
          notifId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      response.push(res.data)
    }

    return response
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}

export const getNotifications = async (token: string, userEmail: string) => {
  try {
    const response = await Axios.get(`${SERVER_BASE_URL}api/notifications/${userEmail}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}

export const setNotificationWatched = async (token: string, notifId: string) => {
  try {
    const response = await Axios.put(
      `${SERVER_BASE_URL}api/notifications/${notifId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}

export const deleteNotification = async (token: string, notifId: string) => {
  try {
    const response = await Axios.delete(`${SERVER_BASE_URL}api/notifications/${notifId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête :', error)
    throw error
  }
}
